// @module MHI.VideoTabInPDP.VideoTabInPDP
define('VideoTabInPDP.View'
,	[
	'videotabinpdp.tpl'
	
	,	'Backbone'
    ]
, function (
	videotabinpdp_tpl
	
	
	,	Backbone
)
{
    'use strict';

	// @class MHI.VideoTabInPDP.VideoTabInPDP.View @extends Backbone.View
	return Backbone.View.extend({

		template: videotabinpdp_tpl

	,	initialize: function (options) {
			var pdp_component = options.container.getComponent('PDP');
			this.youTubeURL = [];
			if(pdp_component.getItemInfo().item.custitem_dhi_installation_video){
				this.youTubeURL.push(this.youtube_parser(pdp_component.getItemInfo().item.custitem_dhi_installation_video))
			}
			if(pdp_component.getItemInfo().item.custitem_dhi_installation_video2){
				this.youTubeURL.push(this.youtube_parser(pdp_component.getItemInfo().item.custitem_dhi_installation_video2))
			}
		}

	,	youtube_parser: function youtube_parser(url){
			var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
			var match = url.match(regExp);
			return (match&&match[7].length==11)? match[7] : false;
		}

		//@method getContext @return MHI.VideoTabInPDP.VideoTabInPDP.View.Context
	,	getContext: function getContext()
		{
			this.youTubeURL = this.youTubeURL || ''
			return {
				youTubeURL: this.youTubeURL
			};
		}
	});
});
